export default __webpack_public_path__ + "static/media/adir-camel.1c31f44f.png";